import {LOG_OUT_MANAGER} from './types';

const logOutManager = () => ({
  type: LOG_OUT_MANAGER,
});

export default logOutManager;
